import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { filter, length, map, maxBy, ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Dta_DtaListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { UploadResult_$reflection, Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { comparePrimitives, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { list_type, class_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Msg, Model } from "./Types.fs.js";
import { errorCmd, request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function Http_getDtaDateien(page) {
    const response = fetch(toText(printf("/api/dta?page=%i"))(page), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(Dta_DtaListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postDta(file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch("/api/dta", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(UploadResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_deleteDta(id) {
    const response = fetch(toText(printf("/api/dta/%A"))(id), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), singleton(new Types_RequestProperties(0, ["DELETE"]))), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(class_type("System.Guid"), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_confirmDta(id) {
    return sendJson("/api/dta/confirm", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(id)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(page, user, lastModel) {
    const pagenumber = page.fields[0] | 0;
    return [new Model(pagenumber, new Remote$1(1, []), 0, false, empty()), singleton((dispatch) => {
        dispatch(new Msg(0, [pagenumber]));
    })];
}

export function State_update(msg, model) {
    let msg_1;
    switch (msg.tag) {
        case 1:
            return [new Model(model.PageNumber, Loaded(msg.fields[0]), model.UploadCount, model.Sending, model.UploadList), Cmd_none()];
        case 2: {
            const biggestFile = maxBy((f) => f.size, msg.fields[0], {
                Compare: comparePrimitives,
            });
            if (biggestFile.size > ((4 * 1024) * 1024)) {
                return [model, (msg_1 = (new Msg(8, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die DTA-Dateien dürfen maximal 4 MB groß sein.")])])), singleton((dispatch) => {
                    dispatch(msg_1);
                }))];
            }
            else {
                const cmd_2 = Cmd_batch(map((f_1) => request(Http_postDta, f_1, (Item_1) => (new Msg(3, [Item_1]))), msg.fields[0]));
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount + length(msg.fields[0]), model.Sending, model.UploadList), cmd_2];
            }
        }
        case 3:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount - 1, model.Sending, model.UploadList), errorCmd((Item_2) => (new Msg(8, [Item_2])), "Upload", msg.fields[0].fields[0])];
            }
            else {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount - 1, model.Sending, append(model.UploadList, singleton(msg.fields[0].fields[0]))), Cmd_none()];
            }
        case 4:
            return [new Model(model.PageNumber, model.DtaList, model.UploadCount, true, model.UploadList), request(Http_deleteDta, msg.fields[0].Id, (Item_3) => (new Msg(5, [Item_3])))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount, false, model.UploadList), errorCmd((Item_4) => (new Msg(8, [Item_4])), "Löschen", msg.fields[0].fields[0])];
            }
            else {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount, false, filter((x_2) => !(x_2.Id === msg.fields[0].fields[0]), model.UploadList)), Cmd_none()];
            }
        case 6:
            return [new Model(model.PageNumber, model.DtaList, model.UploadCount, true, model.UploadList), request(Http_confirmDta, map((x_3) => x_3.Id, model.UploadList), (Item_5) => (new Msg(7, [Item_5])))];
        case 7:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount, false, model.UploadList), errorCmd((Item_6) => (new Msg(8, [Item_6])), "Versenden", msg.fields[0].fields[0])];
            }
            else {
                return [new Model(model.PageNumber, model.DtaList, model.UploadCount, false, empty()), singleton((dispatch_1) => {
                    dispatch_1(new Msg(0, [1]));
                })];
            }
        case 8:
            return [model, Cmd_none()];
        default:
            return [new Model(model.PageNumber, new Remote$1(1, []), model.UploadCount, model.Sending, model.UploadList), request(Http_getDtaDateien, msg.fields[0], (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
